import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface LogoState {
  logoDarkURL: string | null;
  logoLightURL: string | null;
}

const initialState: LogoState = {
  logoDarkURL: null,
  logoLightURL: null,
};

const logoSlice = createSlice({
  name: 'logo',
  initialState,
  reducers: {
    setLogoDark: (state, action: PayloadAction<string>) => {
      state.logoDarkURL = action.payload;
    },
    setLogoLight: (state, action: PayloadAction<string>) => {
      state.logoLightURL = action.payload;
    },
  },
});

export const { setLogoDark, setLogoLight } = logoSlice.actions;

export default logoSlice.reducer;
